/**
 * Special line break that goes between two products of different categories
 */
const createCategorySeparator = (nextCategory, previousCategory) => ({
  categories: {
    next: nextCategory,
    previous: previousCategory,
  },
  display: {
    categorySeparator: true,
  },
});

export default createCategorySeparator;
